/** @format */

import * as actionTypes from 'stateContainer/action-types';

const initialState = {
  showSuccessToast: false,
  showErrorToast: false
};

export const sendEmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SEND_FRILANCE_EMAIL_SUCCESS:
      return { ...state, showSuccessToast: true };

    case actionTypes.SEND_FRILANCE_EMAIL_ERROR:
      return { ...state, showErrorToast: true };

    case actionTypes.RESET_EMAIL_REDUCER:
      return initialState;

    default:
      return state;
  }
};
